import { useDispatch, useSelector } from "react-redux";
import { selectActiveTabFilterIndex, selectAiFilters, selectAiFiltersArray, selectCandidateCv, selectCandidateProfile, selectCandidatesFilters, selectcurrType, selectIsFetchingCandidateData, selectIsFullCv, selectStageChange, setIsFullCv, setStageChange } from "../../../modules/createJob/slice/candidateSlice";
import { getImageUrl } from '../../utils/functions/images';
import ChevronLeft from "../../assets/images/ChevronLeft.svg"
import ChevronLeftDisabled from "../../assets/images/ChevronLeftDisabled.svg"
import ChevronRight from "../../assets/images/ChevronRight.svg"
import ChevronRightDisabled from "../../assets/images/ChevronRightDisabled.svg"
import maximizeCV from "../../assets/images/maximizeCV.svg"
import minimizeCV from "../../assets/images/minimizeCV.svg"
import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { perviousCandidateIndex, ICandidateNavigation, currentTypes, ICandidatesFilter, IAIFilter, GlobalStageTypesId } from "../../utils/interfaces/candidatesListFace";
import { useLazyGetApplicationIDsByAiSearchQuery, useLazyGetApplicationIDsByJobIdQuery } from "../../../modules/createJob/slice/candiddateApiSlice";
import { Skeleton } from "antd";

export const Toolbar:  (state?: any) => any = (state) => {
    const candidateCv = useSelector(selectCandidateCv);
    const candidate = useSelector(selectCandidateProfile)
    const isFullCv = useSelector(selectIsFullCv);
    const currentType = useSelector(selectcurrType);
    const stageChange = useSelector(selectStageChange);
    const aiFiltersArray: { id: number, question: string }[] = useSelector(selectAiFiltersArray);
    const activeSearchTabIndex = useSelector(selectActiveTabFilterIndex);
    const candidatesFilter: ICandidatesFilter = useSelector(selectCandidatesFilters);
    const candidatesAiFilter: IAIFilter = useSelector(selectAiFilters);
    const { hiringStageId } = candidatesFilter
    const isFetchingCandidateData = useSelector(selectIsFetchingCandidateData);
    let [candidatesIds, setCandidatesIds] = useState<ICandidateNavigation[]>([])
    const { applicationId, jobId } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const [totalCandidates, setTotalCandidates] = useState<number>(0)
    const [currentCandidate, setCurrentCandidate] = useState<number>(0)
    const [getIds, { isSuccess: isSuccessIDs, data: applicationIDs, isLoading: isLoadingIDs }] = useLazyGetApplicationIDsByJobIdQuery()
    const [getAiIds, { isSuccess: isSuccessAiIds, data: applicationAiIDs, isLoading: isLoadingAiIDs }] = useLazyGetApplicationIDsByAiSearchQuery()
    
    const handleDownload = () => {
        fetch(candidateCv).then(response => response.blob()).then((blob) => {
            const url = URL?.createObjectURL(blob)
            const fileName = candidateCv.split('/').pop() as string
            const aTag = document.createElement("a")
            aTag.href = url
            aTag.setAttribute("download", fileName)
            document.body.appendChild(aTag)
            aTag.click()
            aTag.remove()
        })
    }

    useEffect(() => {
        const storedCandidatesIds = JSON.parse(localStorage.getItem('candidatesIds') || '[]');
        setCandidatesIds(storedCandidatesIds);
    }, [applicationId]);

    useEffect(() => {
        const refreshing = localStorage.getItem("isRefreshing") === "true";
        if (stageChange !== null && !isFetchingCandidateData && !refreshing) {
            if (!currentCandidate || !totalCandidates) updateCandidatesList()
        }
        // eslint-disable-next-line
    }, [currentCandidate, totalCandidates, isFetchingCandidateData, stageChange])

    const clearStageChange = useCallback(() => {
        dispatch(setStageChange(null))
    }, [dispatch])

    useEffect(()=> {
        if (isSuccessIDs && applicationIDs?.data) {
            setCandidatesIds(applicationIDs?.data);
            localStorage.setItem("candidatesIds", JSON.stringify(applicationIDs?.data));
            setTotalCandidates(applicationIDs?.data?.length);
        }
    }, [isSuccessIDs, applicationIDs])

    useEffect(()=> {
        if (isSuccessAiIds && applicationAiIDs?.data) {
            setCandidatesIds(applicationAiIDs?.data);
            localStorage.setItem("candidatesIds", JSON.stringify(applicationAiIDs?.data));
            setTotalCandidates(applicationAiIDs?.data?.length);
        }
    }, [isSuccessAiIds, applicationAiIDs])

    const updateCandidatesList = useCallback(async () => {
        const currentStageId: number = hiringStageId === candidate?.pipelineHiringStageId ? hiringStageId : candidate?.pipelineHiringStageId
        if (aiFiltersArray && aiFiltersArray?.length) {
            await getAiIds({ jobId, query: aiFiltersArray[activeSearchTabIndex - 1]?.question, ...candidatesAiFilter, hiringStageId: currentStageId });
        } else {
            await getIds({ jobId, ...candidatesFilter, hiringStageId: currentStageId });
        }
    }, [aiFiltersArray, activeSearchTabIndex, candidatesAiFilter, candidatesFilter, getAiIds, getIds, jobId, hiringStageId, candidate?.pipelineHiringStageId]);

    useEffect(() => {
        setTotalCandidates(candidatesIds?.length);
        const currentCandidateIndex = candidatesIds?.findIndex((candidate: ICandidateNavigation) => candidate?.id === Number(applicationId));

        if (currentCandidateIndex !== -1) {
            setCurrentCandidate(currentCandidateIndex + 1);
        }
    }, [candidatesIds, applicationId]);

    const handlePrint = () => {
        const printWindow = window.open(state?.currentDocument?.uri, state?.currentDocument?.uri.split('.').pop() === 'docx' ? '_self' : '_blank') as Window;
        printWindow.addEventListener('load', () => {
            printWindow.print();
        });
    }

    const handleToggleMaximize = () => {
        dispatch(setIsFullCv(!isFullCv))
    }

    const handlePreviousProfile = async () => {
        if (!location?.state?.fromSearch && stageChange !== null && stageChange !== GlobalStageTypesId.rejected) {
            await updateCandidatesList();
        }

        const prevCandidate = candidatesIds[currentCandidate - perviousCandidateIndex]?.id;
        if (prevCandidate) {
            navigate(`/jobs/${jobId}/candidates/${prevCandidate}`, { state: { ...location?.state }, replace: !!stageChange });
            clearStageChange();
        }
    };

    const handleNextProfile = async () => {
        if (!location?.state?.fromSearch && stageChange !== null && stageChange !== GlobalStageTypesId.rejected) {
            await updateCandidatesList();
        }

        const nextCandidate = candidatesIds[currentCandidate]?.id;
        if (nextCandidate) {
            navigate(`/jobs/${jobId}/candidates/${nextCandidate}`, { state: { ...location?.state }, replace: !!stageChange });
            clearStageChange();
        }
    };

    return (
        <div className='sticky top-0 left-0 z-50 flex justify-end w-full pb-5 pr-6 pt-7 bg-light-100'>
            {!location?.state?.fromSimilarity ?
                <div className="flex items-center justify-center flex-grow gap-2 text-sm text-gray-500">
                    {isLoadingIDs || isLoadingAiIDs ? <Skeleton.Button size='small' active className='!w-32 !flex items-center' /> :
                        <>
                    <button disabled={totalCandidates <= 1 || currentCandidate === 1 || totalCandidates === 0 || currentCandidate === 0} >
                        <img src={currentCandidate === 1 ? ChevronLeftDisabled : ChevronLeft} alt="ChevronLeft"
                        className={`${currentCandidate !== 1 ? "cursor-pointer" : "cursor-not-allowed"}`} onClick={handlePreviousProfile} />
                    </button>
                    <p><span className="font-bold">{currentCandidate?.toString()}</span>/<span>{totalCandidates?.toString()}</span></p>
                    <button disabled={totalCandidates <= 1 || currentCandidate >= totalCandidates || totalCandidates === 0 || currentCandidate === 0}>
                        <img src={currentCandidate === totalCandidates ? ChevronRightDisabled : ChevronRight} alt="ChevronRight"
                        className={`${currentCandidate !== totalCandidates ? "cursor-pointer" : "cursor-not-allowed"}`} onClick={handleNextProfile} />
                            </button>
                        </>
                    }
                </div> : null
            }
            <div className='flex justify-end gap-x-4'>
                {currentType === currentTypes.Graph || 
                    <>
                        <img className='cursor-pointer' onClick={handleDownload} src={getImageUrl('download')} alt="download" />
                        <img className='cursor-pointer' onClick={handlePrint} src={getImageUrl('Printer')} alt='print' />
                    </>
                }
                <img className='hidden cursor-pointer lg:block' onClick={handleToggleMaximize} src={isFullCv ? minimizeCV : maximizeCV} alt={`${isFullCv ? 'minimize' : 'maximize'}`} />
            </div>
        </div>
    )
};